const FONT_FAMILY = {
  'Noto Sans': 'Noto Sans KR',
  Pretendard: 'Pretendard',
  나눔명조: '나눔명조',
};

export default FONT_FAMILY;
